<template>
  <div class="login-wrap">
    <div class="user-input block">
      <van-nav-bar
        title="忘记密码"
        fixed
        placeholder
        :z-index="10"
        left-arrow
        @click-left="onClickLeft"
      >
      </van-nav-bar>

      <van-form @submit="loginFn" ref="loginForm">
        <div class="input-area">
          <div class="on-input">
            <img src="/images/login/phone@2x.png" alt="" />
            <van-field
              v-model.trim="form.mobile"
              type="number"
              placeholder="请输入手机号"
              maxlength="11"
            />
          </div>
          <div class="on-input verify-code">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field v-model.trim="form.smsCode" placeholder="请输入验证码" />
            <div
              :class="['send-btn', sending ? 'sending' : '']"
              @click="getCode"
            >
              {{ sending ? `${second}s` : "发送验证码" }}
            </div>
          </div>
          <div class="on-input">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field
              :type="!newPassword ? 'password' : 'text'"
              v-model.trim="form.newPassword"
              placeholder="请输入密码"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="off"
              maxlength="12"
              minlength="6"
              :right-icon="!newPassword ? 'closed-eye' : 'eye-o'"
              @click-right-icon="showPassword('newPassword')"
            />
          </div>
          <div class="on-input">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field
              :type="!reNewPassword ? 'password' : 'text'"
              v-model.trim="form.reNewPassword"
              placeholder="请再次输入"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="off"
              maxlength="12"
              minlength="6"
              :right-icon="!reNewPassword ? 'closed-eye' : 'eye-o'"
              @click-right-icon="showPassword('reNewPassword')"
            />
          </div>
          <div class="tips">
            温馨提示：密码长度6~12位,须包含数字、字母、符号最少2种以上元素
          </div>
          <van-button
            class="large-btn login-btn"
            size="large"
            :loading="loading"
            round
            color="linear-gradient(to right,#46C4FF, #1C97FF)"
            type="info"
            native-type="submit"
            >确定
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import Api from "@/api/user";
import { PasswordReg, IsMobile } from "@/libs/utils";

export default {
  data() {
    return {
      loading: false,
      sending: false,
      newPassword: false,
      reNewPassword: false,
      second: 60,
      form: {
        mobile: "",
        smsCode: "",
        newPassword: "",
        reNewPassword: "",
      },
    };
  },
  methods: {
    async loginFn() {
      try {
        let { mobile, smsCode, newPassword, reNewPassword } = this.form;
        if (!mobile) throw "请输入手机号";
        if (!smsCode) throw "请输入验证码";
        if (!newPassword) throw "请输入密码";
        if (!reNewPassword) throw "请输入确认密码";
        if (newPassword !== reNewPassword) throw "两次密码不一致";
        if (!PasswordReg.test(newPassword)) throw "密码格式不正确";
        this.loading = true;
        await Api.findUserPassword(this.form);
        this.$toast.success("密码重置成功");
        this.$router.back();
      } catch (error) {
        this.$toast.fail(error);
      } finally {
        this.loading = false;
      }
    },
    async getCode() {
      if (this.sending) return;
      if (!IsMobile.test(this.form.mobile)) {
        this.$toast.fail("请输入正确的手机号");
        return;
      }
      try {
        await Api.smsLgcode(this.form.mobile);
        this.$toast.success("验证码已发送，请注意查收！");
        this.sending = true;
        this.itv = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.second = 60;
            this.sending = false;
            clearInterval(this.itv);
          }
        }, 1000);
        return Promise.resolve(true);
      } catch (error) {
        this.sending = false;
        this.$toast.fail(error);
        return Promise.reject(error);
      }
    },
    showPassword(type) {
      this[type] = !this[type];
      this.$nextTick(() => {
        this.$forceUpdate(); // 强制更新组件
      });
    },
  },
};
</script>
<style lang="less" scoped>
.login-wrap {
  background: #ebf6ff;
  padding-bottom: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  .tips {
    color: #999;
    line-height: 20px;
  }
  .user-input {
    margin-top: 16px;
    position: relative;
    padding-top: 20px;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 10px;
      border-radius: 4px 4px 0 0;
      background: #1890ff;
      top: -4px;
      z-index: 0;
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 10px;
      border-radius: 4px 4px 0 0;
      background: #fff;
      top: 0px;
      z-index: 0;
    }
    .title {
      height: 18px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 18px;
      text-align: center;
      margin-bottom: 20px;
    }
    .input-area {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      .on-input {
        margin-bottom: 16px;
        background: #f6fbff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
        border-radius: 24px;
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: 0 16px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
        .van-cell {
          padding: 0;
          background: #f6fbff;
          flex: 1;
          &::after {
            content: unset;
          }
        }
        &.verify-code {
          display: flex;
          justify-content: space-between;
          .send-btn {
            width: 75px;
            height: 14px;
            line-height: 14px;
            border-left: 1px solid #1890ff;
            font-size: 14px;
            font-weight: 400;
            color: #1890ff;
            text-align: center;
            padding-left: 3px;
            &.sending {
              color: #999;
            }
          }
        }
      }
      .login-btn {
        margin-top: 21px;
        width: 280px;
        height: 52px;
        margin-bottom: 16px;
        background: url("/images/login/button@2x.png") no-repeat !important;
        background-size: 100% 100% !important;
      }
    }
  }
}
</style>
